<template>
  <v-container fluid>
    <!-- Tabella -->
    <v-data-table
      :headers="headers"
      fixed-header
      :items="associazioni"
      :items-per-page="10"
      item-key="id_macchina_associazione"
      calculate-widths
      class="elevation-1"
      height="55vh"
    >
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <!-- Pulstanti -->
        <v-toolbar
          dense
          class="rounded rounded-b-0 elevation-0 indigo"
          outlined
        >
          <!-- Aggiungi cassone -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="nuovoCassone()"
                class="ml-auto mr-5"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo Cassone</span>
          </v-tooltip>
          <!-- Visualizza filtri -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-auto ml-5"
                v-bind="attrs"
                v-on="on"
                small
                @click="filters == true ? (filters = false) : (filters = true)"
              >
                <v-icon color="purple"> mdi-filter </v-icon>
              </v-btn>
            </template>
            <span v-if="filters == false">Visualizza Filtri</span>
            <span v-else>Nascondi Filtri</span>
          </v-tooltip>
        </v-toolbar>
        <!-- Row Filtri -->
        <v-row justify="center" v-if="filters === true" class="ma-1">
          <v-col cols="5" md="4">
            <v-text-field
              @change="filtra()"
              v-model="codice_tipo_filter"
              label="Cod. Tipo"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="5" md="4">
            <v-text-field
              @change="filtra()"
              v-model="desc_tipo_filter"
              label="Desc. Tipo"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="1">
            <!-- Reset filtri -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mt-5"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="resetFiltri()"
                >
                  <v-icon color="error"> mdi-filter-off </v-icon>
                </v-btn>
              </template>
              <span>Resetta Filtri</span>
            </v-tooltip>
          </v-col>
          <!-- Tasto filtra -->
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="filtra()"
                  class="mt-4 success"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Filtra</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <!-- Pulsante edit -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                create_edit_dialog = true;
              "
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Codice cassone -->
      <template v-slot:[`item.cod_macchina`]="{ item }">
        {{
          tot_cassoni.filter((c) => c.id_macchina === item.id_associazione)
            .length > 0
            ? tot_cassoni.filter(
                (c) => c.id_macchina === item.id_associazione
              )[0].cod_macchina
            : "N/D"
        }}
      </template>
      <!-- Matricola cassone -->
      <template v-slot:[`item.matricola`]="{ item }">
        {{
          tot_cassoni.filter((c) => c.id_macchina === item.id_associazione)
            .length > 0
            ? tot_cassoni.filter(
                (c) => c.id_macchina === item.id_associazione
              )[0].extra[0].matricola
            : "N/D"
        }}
      </template>
      <!-- tipo_veicolo -->
      <template v-slot:[`item.tipo_veicolo`]="{ item }">
        {{
          tipo_veicolo.filter((t) => t.id_tabella === item.id_tipo_associazione)
            .length > 0
            ? tipo_veicolo.filter(
                (t) => t.id_tabella === item.id_tipo_associazione
              )[0].des
            : "N/D"
        }}
      </template>
      <!-- Pulsante rimuovi -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                delete_dialog = true;
              "
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Create/edit dialog -->
    <v-dialog persistent v-model="create_edit_dialog" max-width="700">
      <v-card min-height="50vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            <span v-if="selected_item.id_macchina === null">Nuovo</span>
            <span v-else>Modifica</span>
          </v-toolbar-title>
          <!-- Salva modifica -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                @click="salvaCassone()"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Cassone</span>
          </v-tooltip>
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto"
                @click="create_edit_dialog = false"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <!-- Input -->
          <v-row justify="center" class="mt-10">
            <v-col cols="8">
              <!-- @change="test" -->
              <v-autocomplete
                label="Matricola"
                @change="changeTipo"
                v-model="selected_item.id_associazione"
                dense
                hide-details
                :items="cassoni"
                item-value="id_macchina"
                item-text="extra[0].matricola"
              />
            </v-col>
            <v-col cols="8">
              <v-text-field
                :items="tipo_veicolo"
                readonly
                label="Tipo Veicolo"
                dense
                hide-details
                class="mt-5"
                :value="tipo_veicolo.filter((t)=>t.id_tabella==selected_item.id_tipo_associazione).length>0
                ?tipo_veicolo.find((t)=>t.id_tabella==selected_item.id_tipo_associazione).des
                : ''"
              />
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="selected_item.cod_macchina"
                label="Cod. Cassone"
                dense
                hide-details
                class="mt-5"
              />
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="selected_item.note"
                label="Descrizione"
                dense
                hide-details
                class="mt-5"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog persistent v-model="delete_dialog" max-width="700">
      <v-card min-height="30vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  selected_item.validita = 0;
                  salvaCassone();
                "
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="delete_dialog = false"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text class="mt-10">
          <p class="black--text">
            Sei sicuro di voler eliminare il cassone
            <!-- {{ selected_item.cod_macchina }}? -->
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Associazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_macchina", default_val: null },
      { nome: "id_associazione", default_val: null },
      { nome: "id_macchina_associazione", default_val: null },
      { nome: "id_tipo_associazione", default_val: null },
      { nome: "note", default_val: "" },
      { nome: "cod_macchina", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}
export default {
  name: "QLCassoniComponent",

  components: {
    SnackbarQV,
  },

  props: {
    veicolo_associazione: Object,
  },

  data() {
    return {
      overlay: false,
      // Cassone selezionato
      selected_item: new Associazione(),
      // Filtri
      codice_tipo_filter: "",
      desc_tipo_filter: "",
      // Variabili tabella/crea/modifica/filtri
      create_edit_dialog: false,
      delete_dialog: false,
      filters: false,
      // Array
      // cassoni visibili
      cassoni: [],
      tot_cassoni: [],
      tipo_veicolo: [],
      cassoni_associati: [],
      associazioni: [],
      tot_associazioni: [],
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
        },
        {
          text: "Matricola",
          value: "matricola",
          filterable: false,
          sortable: false,
        },
        {
          text: "Tipo",
          value: "tipo_veicolo",
          filterable: false,
          sortable: false,
        },
        {
          text: "Cod. Tipo",
          value: "cod_macchina",
          filterable: false,
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "note",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
        },
      ],
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    changeTipo() {
      if (
        this.tot_cassoni.filter(
          (c) => c.id_macchina == this.selected_item.id_associazione
        ).length > 0
      ) {
        let cassone_sel = this.tot_cassoni.find(
          (c) => c.id_macchina == this.selected_item.id_associazione
        ).extra[0];
        this.tipo_veicolo.filter((t) => t.id_tabella == cassone_sel.id_tipo)
          .length > 0
          ? (this.selected_item.id_tipo_associazione = this.tipo_veicolo.find(
              (t) => t.id_tabella == cassone_sel.id_tipo
            ).id_tabella)
          : "";
      } else {
        return;
      }
    },
    // Cassone selezionato
    selectItem(item) {
      // console.log(item);
      this.selected_item = new Associazione(JSON.parse(JSON.stringify(item)));
      // Riempo il campo cod_macchina e cassone dell'abilitazione
      //con quelli del cassone associato
      this.selected_item.cod_macchina =
        this.tot_cassoni.filter(
          (c) => this.selected_item.id_associazione === c.id_macchina
        ).length > 0
          ? this.tot_cassoni.filter(
              (c) => this.selected_item.id_associazione === c.id_macchina
            )[0].cod_macchina
          : "";
      this.selected_item.id_associazione =
        this.tot_cassoni.filter(
          (c) => this.selected_item.id_associazione === c.id_macchina
        ).length > 0
          ? (this.selected_item.id_associazione = this.tot_cassoni.filter(
              (c) => this.selected_item.id_associazione === c.id_macchina
            )[0].id_macchina)
          : "";
      this.cassoni = [];
      this.tot_cassoni.forEach((c) => {
        if (
          this.cassoni_associati.includes(c.id_macchina) == false ||
          this.selected_item.id_associazione === c.id_macchina
        ) {
          this.cassoni.push(c);
        }
      });
    },
    // Nuovo Cassone
    nuovoCassone() {
      this.create_edit_dialog = true;
      this.selected_item = new Associazione();
      this.cassoni = [];
      this.tot_cassoni.forEach((c) => {
        if (this.cassoni_associati.includes(c.id_macchina) == false) {
          this.cassoni.push(c);
        }
      });
    },
    // Aggiungi cassone
    salvaCassone() {
      console.log(this.selected_item);
      console.log(this.veicolo_associazione);
      const c = this.cassoni.find(
        (c) => c.id_macchina === this.selected_item.id_associazione
      );
      let request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setmacchina",
          token: localStorage.getItem("user_token"),
          tabella: [
            {
              id_macchina: this.selected_item.id_associazione,
              id_tipo_get_macchina: c.id_tipo_get_macchina,
              cod_macchina: this.selected_item.cod_macchina,
              validita: 1,
            },
          ],
        },
      };
      let associazione = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "savemacchinaassociazione",
          token: localStorage.getItem("user_token"),
          associazione: {
            id_macchina_associazione:
              this.selected_item.id_macchina_associazione,
            id_macchina: this.veicolo_associazione.id_macchina,
            id_associazione: this.selected_item.id_associazione,
            id_tipo_associazione: this.selected_item.id_tipo_associazione,
            note: this.selected_item.note,
            validita: this.selected_item.validita,
          },
        },
      };
      // FACCIO ASSOCIARE UN NUOVO CASSONE SOLO SE NON E GIA STATO ASSOCIATO
      if (
        this.cassoni_associati.includes(this.selected_item.id_associazione) ==
          false ||
        this.selected_item.id_macchina_associazione !== null
      ) {
        this.overlay = true;
        this.$store
          .dispatch("api6", associazione)
          .then((res) => {
            this.overlay = false;
            if (res.status == 200) {
              this.getCassoni();
              this.overlay = true;
              this.$store
                .dispatch("api", request)
                .then((res) => {
                  this.overlay = false;
                  if (res.status == 200) {
                    this.getCassoni();
                    this.$refs.SnackbarQV.print(
                      "success",
                      "Cassone salvato correttamente."
                    );
                  } else {
                    this.getCassoni();
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                  }
                })
                .catch((e) => console.error(e));
            } else {
              this.overlay = false;
              this.getCassoni();
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
            }
          })
          .catch((e) => console.log(e));
        this.filtra();
        this.create_edit_dialog = false;
        this.delete_dialog = false;
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Errore, cassone gia associato a questo veicolo"
        );
      }
    },
    aggiornaAutocomplete() {
      const tipo_veicolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "EG_TIPO_VEICOLO",
          filter: `validita = 1`,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", tipo_veicolo).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.tipo_veicolo = res.data ? res.data : [];
          console.log(this.tipo_veicolo);
          // console.table(this.unita_misura);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },
    getCassoni() {
      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
          val_txt: "RISORSE_LOGISTIC",
          filter: "validita=1",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getlistamacchine).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.tot_cassoni = [];
          this.cassoni = [];
          res.data.macchine.forEach((e) => {
            if (e.extra.length > 0 && e.id_tipo_get_macchina != 33570) {
              this.tot_cassoni.push(e);
            }
          });
          this.cassoni = Array.from(this.tot_cassoni);
          console.log(this.tot_cassoni);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
      let request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getmacchinaassociazioni",
          token: localStorage.getItem("user_token"),
          id_macchina: this.veicolo_associazione.id_macchina,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api6", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.tot_associazioni = [];
          this.cassoni_associati = [];
          res.data.result.forEach((e) => {
            if (e.validita == true) {
              this.tot_associazioni.push(e);
            }
          });
          this.associazioni = Array.from(this.tot_associazioni.reverse());
          this.associazioni.forEach((a) => {
            this.cassoni_associati.push(a.id_associazione);
          });
          console.table(this.associazioni);
          console.log(this.associazioni);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    // Filtri
    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare i cassoni filtrati */
      let cassoni_tmp = [];
      this.tot_cassoni.forEach((v) => {
        cassoni_tmp.push(new Associazione(v));
      });

      //Filtro per tipo
      if (this.codice_tipo_filter != "") {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (
            elem.cod_macchina
              .toUpperCase()
              .includes(this.codice_tipo_filter.toUpperCase())
          ) {
            res.push(new Associazione(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Associazione(e));
        });
      }
      //Filtro per descrizione
      if (this.desc_tipo_filter != "") {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (
            elem.note
              .toUpperCase()
              .includes(this.desc_tipo_filter.toUpperCase())
          ) {
            res.push(new Associazione(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Associazione(e));
        });
      }

      // Ricostruisco i cassoni visualizzati in base ai filtri aggiunti.
      (this.cassoni = []), (this.cassoni = Array.from(cassoni_tmp));
    },
    resetFiltri() {
      (this.codice_tipo_filter = ""),
        (this.desc_tipo_filter = ""),
        this.filtra();
    },
  },

  created() {},

  mounted() {
    this.aggiornaAutocomplete();
    this.getCassoni();
  },
};
</script>